import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/polymerize/ring/new',
    owner: '/home',
    component: Loadable({
      loader: () => import('./new'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/polymerize/ring/:id/mod',
    owner: '/home',
    component: Loadable({
      loader: () => import('./mod'),
      loading: () => <RouteLoading />
    })
  },
];